import {
  ListItem,
  ListItemAvatar,
  ListItemText,
  Box,
  useTheme,
  Typography,
} from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";
import DocumentSignatureRequestedIcon from "../../../common/icons/document/documentSignatureRequestedIcon";
import * as api from "../../../../api/generated-api";
import Button from "../../../common/forms/button";
import DocumentSignatureSignedIcon from "../../../common/icons/document/documentSignatureSignedIcon";

type Props = {
  orgId: number;
  dealId: number;
  dealDocumentSignature: api.DealDocumentSignature;
  isSelected: boolean;
  isSignButtonVisible?: boolean;
  onSignDocumentClick: (documentSinger: api.DealDocumentSignature) => void;
};

const DocumentSignatureListItemRow = ({
  orgId,
  dealId,
  dealDocumentSignature,
  isSelected,
  isSignButtonVisible = true,
  onSignDocumentClick,
}: Props) => {
  const theme = useTheme();
  const history = useHistory();

  return (
    <ListItem
      key={dealDocumentSignature.id}
      data-testid={
        dealDocumentSignature.status === api.SigningStatus.signed
          ? "signed-document-list-item"
          : "unsigned-document-list-item"
      }
      sx={{
        backgroundColor: isSelected
          ? theme.palette.primary.lighter
          : "transparent",
        paddingTop: "5px",
      }}
    >
      <ListItemAvatar>
        {dealDocumentSignature.status === api.SigningStatus.requested ? (
          <DocumentSignatureRequestedIcon />
        ) : (
          <DocumentSignatureSignedIcon />
        )}
      </ListItemAvatar>
      <ListItemText>
        <Box
          sx={{
            fontWeight: isSelected ? "bold" : "normal",
          }}
          onClick={() => {
            history.push(
              `/${orgId}/deals/${dealId}/documents/${dealDocumentSignature.dealDocumentId}/sign/${dealDocumentSignature.id}`
            );
          }}
        >
          <Typography variant="link">
            {dealDocumentSignature.dealDocument.name}
          </Typography>
        </Box>
      </ListItemText>
      {isSignButtonVisible &&
        dealDocumentSignature.status === api.SigningStatus.requested && (
          <Button
            id={String(dealDocumentSignature.id)}
            data-testid="button-sign-document"
            size="small"
            //type="ghost"
            onClick={() => {
              onSignDocumentClick(dealDocumentSignature);
            }}
          >
            sign
          </Button>
        )}
    </ListItem>
  );
};

export default DocumentSignatureListItemRow;
